/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import { map } from '@neo/ramda-extra'
import { s, styled } from '@vega/styled/v2'
import { formatDateString } from 'utils/date'
import { Tooltip } from '@mui/material'
import FunderStatus from 'components/FunderStatus'

const headerStyleBase = (customStyles) =>
  s(' inline-block text-grey-600 text-left text-xs font-semibold', {
    ...customStyles,
  })

const cellStyleBase = (customStyles) =>
  s(' inline-block text-grey-800 text-sm text-left flex items-center', {
    ...customStyles,
  })

const TextOverflowEllipsis = styled.span({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const Columns = () => {
  return React.useMemo(
    () => [
      {
        Header: 'Added Date',
        accessor: (row) => formatDateString(row.createdAt),
        tableHeaderStyles: headerStyleBase({ width: '10%' }),
        tableCellStyles: cellStyleBase({ width: '10%' }),
        Cell: ({ value }) => (
          <Tooltip title={value}>
            <TextOverflowEllipsis>{value}</TextOverflowEllipsis>
          </Tooltip>
        ),
      },
      {
        Header: 'Funder ID',
        accessor: (row) => row.funderNumber || row._id,
        tableHeaderStyles: headerStyleBase({ width: '20%' }),
        tableCellStyles: cellStyleBase(s('font-semibold', { width: '20%' })),
        Cell: ({ value }) => (
          <Tooltip title={value}>
            <TextOverflowEllipsis>{value}</TextOverflowEllipsis>
          </Tooltip>
        ),
      },
      {
        Header: 'Organisation',
        accessor: 'organisationName',
        tableHeaderStyles: headerStyleBase({ width: '25%' }),
        tableCellStyles: cellStyleBase({ width: '25%' }),
        Cell: ({ value }) => (
          <Tooltip title={value}>
            <TextOverflowEllipsis>{value}</TextOverflowEllipsis>
          </Tooltip>
        ),
      },
      {
        Header: 'Funder Contact',
        accessor: 'fullContactName',
        tableHeaderStyles: headerStyleBase({ width: '25%' }),
        tableCellStyles: cellStyleBase({ width: '25%' }),
        Cell: ({ value }) => (
          <Tooltip title={value}>
            <TextOverflowEllipsis>{value}</TextOverflowEllipsis>
          </Tooltip>
        ),
      },
      {
        Header: 'Status',
        accessor: (row) => row,
        tableHeaderStyles: headerStyleBase({ width: '20%' }),
        tableCellStyles: cellStyleBase({ width: '20%' }),
        Cell: ({ value }) => <FunderStatus funder={value} />,
      },
    ],
    []
  )
}

export const TableData = ({ funders }) => {
  return React.useMemo(
    () =>
      map((funder) => {
        const fullContactName = `${funder.contactFirstName} ${funder.contactLastName}`

        return {
          ...funder,
          id: funder._id,
          fullContactName,
        }
      }, funders),
    [funders]
  )
}
